import { SxProps, useTheme } from '@mui/material';

import { IStyles } from '../../interfaces/styles';
import { ScreenSizes } from '../../interfaces';

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      '& div': {
        border: 'none',
      },
    },

    container: {
      width: 340,
      pt: 0,
      border: 'none',
      borderRadius: '8px',
      boxShadow: '0 6px 24px rgba(0, 0, 0, 0.4)',
    } as SxProps,

    content: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        mx: -1,
      },
    },
    contentWrapper: {},
  };
};
